/**
 * A name-tag nobody can guess.
 *
 * One line, and its own file, because it is the one thing the realm needed
 * from Node: `randomUUID` out of `node:crypto`. A browser has the same
 * function on the same object - `crypto.randomUUID` is standard in both -
 * so all this does is reach for it in the way that works in either.
 *
 * The fallback is deliberately weak and deliberately there: an old browser
 * without `randomUUID` should hand out a worse tag rather than fail to let
 * anybody into the world at all. Tags are proof that this browser is the one
 * that claimed a name a minute ago, not a secret worth money.
 */
export function newToken(): string {
  const maybe = globalThis.crypto as { randomUUID?: () => string } | undefined;
  if (typeof maybe?.randomUUID === "function") return maybe.randomUUID();
  return `t-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}
